var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeAtackFill = function SvgTimeAtackFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m.25 1.009c-.113-.008-.17-.012-.21.025S6 2.631 6 2.75v3.105c0 .07 0 .106-.017.135-.016.03-.047.047-.108.082l-2.69 1.553c-.103.06-.154.09-.166.143s.019.1.083.194A3.5 3.5 0 1 0 6.25 2.509"
  })));
};
export default SvgTimeAtackFill;